import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Header from './components/header';
import Footer from './components/footer';
import Home from './pages/home';
import Galleries from './pages/galleries';
import Gallery from './pages/gallery';
import ClubLinks from './pages/clubLinks';
import About from './pages/about';
import Programme from './pages/programme';
import Exhibition from './pages/exhibition';
import ExhibitionAwards from './pages/exhibitionAwards';
import Contact from './pages/contact';
import './App.css';

class App extends Component {
  render() {
    return (
      <div>
        <BrowserRouter>
          <div>
            <Header />
            <Switch>
              <Route exact path='/' component={ Home }/>
              <Route path='/galleries' component={ Galleries }/>
              <Route path='/gallery/:photographerId' component={ Gallery }/>
              <Route path='/programme' component={ Programme }/>
              <Route exact path='/exhibition' component={ Exhibition }/>
              <Route exact path='/exhibition/awards' component={ ExhibitionAwards }/>
              <Route path='/links' component={ ClubLinks }/>
              <Route path='/about' component={ About }/>
              <Route path='/contact' component={ Contact }/>
            </Switch>
            <Footer />
          </div>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js